'use strict';

require('../../style/index.less');

require('./index.less');

require('../../select/style');

require('../../input/style');


/*****************
 ** WEBPACK FOOTER
 ** ./components/pagination/style/index.tsx
 ** module id = 150
 ** module chunks = 0
 **/